import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CommonProperties, Color, CommonStyles } from '../../../styles';
import BaseText from '../../BaseText';
import RowView from '../../RowView';
import moment from 'moment';

const EventItem = ({ item, isLast }) => {
  return (
    <RowView>
      <BaseText style={styles.event}>{item.day}</BaseText>
      <View style={[CommonStyles.centerItems, CommonStyles.pl2, CommonStyles.pr3]}>
        {item.activities.map((_, index) => {
          if (index === 0 || _.limiter) {
            return (
              <>
                <View style={styles.dayCircle} />
                {!(isLast && index === item.activities.length - 1) ? (
                  <View style={styles.daySeparator} />
                ) : null}
              </>
            );
          } else {
            return (
              <>
                <View style={styles.activityCircle} />
                {!(isLast && index === item.activities.length - 1) && (
                  <View style={styles.activitySeparator} />
                )}
              </>
            );
          }
        })}
      </View>
      <View>
        {item.activities.map((activity) => (
          <BaseText key={activity.Title} style={styles.activityContent}>
            {activity.EventDate ? moment(activity.EventDate).format('HH:mm a') + ' ' : ''}
            {activity.Title}
          </BaseText>
        ))}
      </View>
    </RowView>
  );
};

const styles = StyleSheet.create({
  event: {
    color: Color.text.medium,
    maxWidth: '25%',
    width: '25%',
    minWidth: '25%',
    textAlign: 'right',
    ...CommonProperties.small,
    ...CommonProperties.pr2,
  },
  dayCircle: {
    backgroundColor: 'white',
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#d1d3d4',
    zIndex: 2,
  },
  daySeparator: {
    width: 2,
    height: 13,
    backgroundColor: '#d1d3d4',
  },
  activityCircle: {
    width: 16,
    height: 16,
    borderRadius: 10,
    backgroundColor: '#d1d3d4',
  },
  activitySeparator: {
    width: 2,
    height: 16,
    backgroundColor: '#d1d3d4',
  },
  activityContent: {
    height: 20,
    maxHeight: 20,
    justifyContent: 'center',
    marginBottom: 12,
    paddingTop: 2,
  },
});

export default EventItem;
